import { useEffect, useState } from "react";

const reduced = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

/** Count a number up from 0 with an ease-out curve. Respects prefers-reduced-motion. */
export const useCountUp = (value, duration = 750) => {
  const target = Number(value) || 0;
  const [v, setV] = useState(reduced() ? target : 0);
  useEffect(() => {
    if (reduced()) { setV(target); return undefined; }
    let raf;
    const start = performance.now();
    const from = 0;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const e = 1 - (1 - p) ** 3;
      setV(Math.round(from + (target - from) * e));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  return v;
};

export const CountUp = ({ value, className, testId }) => {
  const v = useCountUp(value);
  return <span className={className} data-testid={testId}>{v.toLocaleString("nb-NO")}</span>;
};
